function getUpdatedDataReduxUtil (instance) {
  return {
    className: instance.className,
    ...instance.data,
    ...instance.changed
  }
}

export default getUpdatedDataReduxUtil
